import { createFileRoute, redirect } from '@tanstack/react-router';

/** Old Platform ▸ Schedules address: the page is now its own sidebar item at /schedules. */
export const Route = createFileRoute('/_authenticated/_tenant/platform/schedules')({
  beforeLoad: ({ search }) => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: '/schedules', search, replace: true });
  },
});
